@if(isDropdownOpen && !disabled){
<div class="overlay">
  @if(hasDropdown){
  <div class="position-dropdown-center" #content>
    <ng-content select=".dropdown-content"></ng-content>
  </div>
  }
</div>
}
<div class="dropdown dropdown--remove-arrow" (click)="toggleDropdown($event)">
  <ng-content select=".dropdown-panel"></ng-content>
</div>